import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import permitIcon from '../../../../icons/violation.png';
import ListPage from '../../../../components/moduleBuilder/ListPage';
import Loading from '../../../../components/loading';
import { getDefectVehicles } from '../../redux/action';
import Forbidden from '../../../Forbidden';

const DefectLog=() => {
  const dispatch = useDispatch();
  const defectVehicles = useSelector(state => state.permitManagement?.defectVehicles) || [];
  const defectVehiclesAction = useSelector(state => state.permitManagement?.defectVehiclesAction);
  const profile = useSelector(state => state.auth.profile);
  const tableHeaders = [
    ['defect_at', 'Date'],
    ['category', 'Category'],
    ['sub_category', 'Sub Category'],
    ['company_name', `${profile.permit_management?.companies || 'Company'} Name`],
    ['veh_reg_no', 'Registration Number'],
    ['description', 'Description'],
    ['status', 'Status']
  ];
  const tags = [
    ['Pending Review', 'pending_review', 'rgb(254,247,229)', '#3c62a8'],
    ['Rejected', 'rejected', 'rgb(255, 87, 51 )', 'rgb(255, 87, 51 )'],
    ['Open', 'open', '#404040', '#404040'],
    ['Closed', 'closed', 'rgb(239,250,227)', 'rgb(113,215,88)']
  ];
  const SummaryStatus={ 'Open': 'open', 'Closed': 'closed', 'Rejected': 'rejected', 'Pending Review': 'pending_review' };
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState('pending_review');

  const handleStatusFilter=(value) => {
    setStatus(SummaryStatus[value]);
    dispatch(getDefectVehicles(page, '', SummaryStatus[value]));
  };

  const onSubmitSearch=(value) => {
    dispatch(getDefectVehicles(page, value, status));
  };

  useEffect(() => {
    setLoader(true);
    dispatch(getDefectVehicles(page, '', status));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (defectVehiclesAction.success || defectVehiclesAction.error) {
        setLoader(false);
    }
  }, [defectVehiclesAction]);

  return (
    <>
      <Loading loadingStatus={loader} />
      {profile?.permissions?.vehicle_permit.includes('view_vehiclepermit')
      ?<ListPage
          tableHeadders={tableHeaders}
          icon={permitIcon}
          logData={defectVehicles.results || []}
          sectionHeader={{ default: profile?.permit_management?.vehicle_defect || 'Defects', id: ' ' }}
          tabTitle={{ default: `${profile?.permit_management?.vehicle_defect || 'Defects'} (${defectVehicles.count || 0})`, id: ' ' }}
          totalRecords={defectVehicles.count || 0}
          searchEnable
          onSubmitSearch={onSubmitSearch}
          setPage={setPage}
          page={page}
          tags={tags}
          summary={defectVehicles.summary}
          handleStatusFilter={handleStatusFilter}
          route={'/avp/vehicle_defect'}
        />
        :<Forbidden />
        }
    </>);
};

export default DefectLog;
